import { Box, Flex, Text, Menu, MenuButton, MenuList, MenuItem, Button } from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { useState } from "react";


const getStatusColor = (status) => {
    const colors = {
        "Completed": "#2ECC71",  
        "To Do": "#3498DB",  
        "On Hold": "#E74C3C",  
        "In Progress": "#8E44AD",  
        "Pending": "#F1C40F" 
    };
    return colors[status] || "#000"; 
};

const CustomStatusDropdown = ({ statusOptions, defaultStatus, onStatusChange }) => {
    const [status, setStatus] = useState(defaultStatus);

    const handleStatusChange = (newStatus) => {
        setStatus(newStatus);
        if (onStatusChange) {
            onStatusChange(newStatus);
        }
    };

    return (
        <Menu>
            <MenuButton
                as={Button}
                rightIcon={<ChevronDownIcon />}
                px="12px"
                py="6px"
                borderRadius="8px"
                bg="transparent"
                border="1px solid #D1D5DB"
                color="black"
                _hover={{ bg: "gray.100" }}
                transition="0.2s"
                width="180px" 
                textAlign="left"
            >
                <Flex alignItems="center" gap="8px">
                    {status && (
                        <Box borderRadius="50%" h="8px" w="8px" backgroundColor={getStatusColor(status)} />
                    )}
                    <Text fontWeight="medium" fontSize="14px" color={status ? getStatusColor(status) : "black"}>
                        {status || "Select Status"}
                    </Text>
                </Flex>
            </MenuButton>
            <MenuList boxShadow="lg" borderRadius="8px" bg="white" minW="180px"> 
                {statusOptions.map((option) => (
                    <MenuItem key={option} onClick={() => handleStatusChange(option)} _hover={{ bg: "gray.100" }}>
                        <Flex alignItems="center" gap="8px">
                            <Box borderRadius="50%" h="8px" w="8px" backgroundColor={getStatusColor(option)} />
                            <Text fontSize="14px">{option}</Text>
                        </Flex>
                    </MenuItem>
                ))}
            </MenuList>
        </Menu>
    );
};

export default CustomStatusDropdown;
